import 'jquery-inview/jquery.inview.min';

import 'chart.js/dist/Chart.min.js';

export default {
  init() {
    // JavaScript to be fired on all pages
    /* LazyLoading Img */
    window.img_lazyloading = function() {
      var lazyImages = [].slice.call(document.querySelectorAll('img.lazy'));

      if ('IntersectionObserver' in window) {
        var lazyImageObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if(entry.isIntersecting) {
              var lazyImage = entry.target;
              lazyImage.src = lazyImage.dataset.src;
              if (lazyImage.dataset.srcset) {
                lazyImage.srcset = lazyImage.dataset.srcset;
              }
              lazyImage.classList.remove('lazy');
              lazyImageObserver.unobserve(lazyImage);
            }
          });
        });

        lazyImages.forEach(function(lazyImage) {
          lazyImageObserver.observe(lazyImage);
        });
      } else {
        $('img.lazy').each(function(){
          $(this).attr('src', $(this).attr('data-src'));
        });
      }

      // Bg img
      var BGlazyImages = [].slice.call(document.querySelectorAll('.bg-lazy'));

      if ('IntersectionObserver' in window) {
        var BGlazyImageObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            if(entry.isIntersecting) {
              var lazyImage = entry.target;
              lazyImage.style.backgroundImage = 'url('+lazyImage.dataset.src+')';
              lazyImage.classList.remove('bg-lazy');
              BGlazyImageObserver.unobserve(lazyImage);
            }
          });
        });

        BGlazyImages.forEach(function(lazyImage) {
          BGlazyImageObserver.observe(lazyImage);
        });
      } else {
        $('.bg-lazy').each(function(){
          $(this).css('background-image', 'url('+$(this).attr('data-src')+')');
        });
      }
    };
    // eslint-disable-next-line no-undef
    img_lazyloading();
    /* END LazyLoading Img */

    /* Menu */
    $('.menu-trigger').click(function(){
      var classes = $(this).find('.nav-icon').attr('class');
      if(classes.indexOf('open') != -1){
        $('.sidenav').removeClass('open');
        //$('.overlay-fullsize').css('visibility', 'hidden');
        $(this).find('.nav-icon').removeClass('open');
        $('body').removeClass('active-menu');
      }else {
        $('.sidenav').addClass('open');
        //$('.overlay-fullsize').css('visibility', 'visible');
        $(this).find('.nav-icon').addClass('open');
        $('body').addClass('active-menu');
      }
      return false;
    });
    /*$('.overlay-fullsize').click(function(){
      $('.menu-trigger').trigger('click');
    });*/
    $(document).ready(function() {
      var header_height = $('header').outerHeight();
      $('.sidenav').css('top', header_height + 'px');
      $('.sidenav').css('max-height', 'calc(100% - ' + header_height + 'px - 2rem)');
      $('main').css('padding-top', header_height + 'px');
    });

    // Sub Menu
    $('.nav-primary .level-0').hover(function() {
      $(this).find('#'+$(this).attr('data-menuid')).addClass('active');
      $('body').addClass('active-menu');
    }, function() {
      $(this).find('#'+$(this).attr('data-menuid')).removeClass('active');
      $('body').removeClass('active-menu');
    });
    $('.nav-primary .level-1-link').hover(function() {
      $('.nav-primary .level-1-link').removeClass('active');
      $('.nav-primary .level-2').removeClass('active');
      $(this).find('#'+$(this).attr('data-id')).addClass('active');
      $(this).addClass('active');
    });

    // Sub Menu Mobile
    $('.sidenav .level-0').hover(function() {
      $(this).find('ul').addClass('active');
    }, function() {
      $(this).find('ul').removeClass('active');
    });

    $('.has-submenu').hover(function() {
      $('header .deco').addClass('visible');
    }, function() {
      $('header .deco').removeClass('visible');
    });

    $('.sidenav .wrapper .nav .icon').click(function() {
      $(this).toggleClass('open');
      $(this).parents('.has-submenu').find('.item-sub-wrapper').toggleClass('open');
    });
    /* END Menu */

    /* Notif Cookies */
    $('.notif a').click(function() {
      $.ajax({
        // eslint-disable-next-line no-undef
        url: ajax_object.ajaxurl,
        type: 'POST',
        data: {'action': 'hide_notif'},
        success: function(  ){
          $('.notif').addClass('close');
        },
      });
      return false;
    });
    /* END Notif Cookies */

    /* INPUT */
    $('.input').focus(function() {
      $(this).parent('.form-group').find('label').addClass('active'); //hide label of clicked item
    }).blur(function() {
      var val = $(this).val();
      if( val == '' ) {
        $(this).parent('.form-group').find('label').removeClass('active');
      }
    });

    $(document).ready(function() {
      $('.input').each(function() {
        if( $(this).val() != '' ) {
          $(this).parent('.form-group').find('label').addClass('active');
        }
      });
    });
    /* END INPUT */

    /* Scroll to Top */
    $(document).scroll(function() {
      if( $(window).scrollTop() > 800 ) {
        $('.scroll-to-top').show();
      }else {
        $('.scroll-to-top').hide();
      }
    });
    $('.scroll-to-top').click(function() {
      $('html, body').animate({ scrollTop: 0 }, 800);
      return false;
    });
    /* END Scroll to Top */

    /* Print btn */
    $('.print-link').click(function() {
      window.print();
      return false;
    });
    /* END Print btn */

    /* Section Number InView */
    $('body').ready(function() {
      $('.section-numbers').on('inview', function(event, isInView) {
        var scrollspy = $(this).attr('data-scrollspy');
        if (isInView && scrollspy == '0') {
          // element is now visible in the viewport
          $('.section-numbers .item').each(function () {
            var number = $(this).find('.number-line').data('number');
            $(this).find('.number-line .complete').css('width', number+'%');
            /*$(this).prop('Counter',0).animate({
                Counter: $(this).text(),
            }, {
                duration: 4000,
                easing: 'swing',
                step: function (now) {
                    $(this).text(Math.ceil(now));
                },
            });*/
          });
          $(this).attr('data-scrollspy', '1');
        }
      });
    });
    /* END Section Number InView */

    /* Slider */
    $('.owl-slider').owlCarousel({
      loop: true,
      autoplay: true,
      margin: 0,
      nav: false,
      items: 1,
      lazyLoad: true,
      dots: false,
      navText: [
        '<svg xmlns="http://www.w3.org/2000/svg" width="24.97" height="41.971" viewBox="0 0 24.97 41.971"><path id="Union_2" data-name="Union 2" d="M18.142,40.8,1.172,23.828a4.035,4.035,0,0,1,0-5.686l16.97-16.97A4,4,0,1,1,23.8,6.828L9.642,20.986,23.8,35.142A4,4,0,0,1,18.142,40.8Z" transform="translate(0)" fill="#fff"/></svg>',
        '<svg xmlns="http://www.w3.org/2000/svg" width="24.97" height="41.971" viewBox="0 0 24.97 41.971"><path id="Union_3" data-name="Union 3" d="M18.142,40.8,1.172,23.828a4.035,4.035,0,0,1,0-5.686l16.97-16.97A4,4,0,1,1,23.8,6.828L9.642,20.985,23.8,35.142A4,4,0,1,1,18.142,40.8Z" transform="translate(24.97 41.971) rotate(180)" fill="#fff"/></svg>',
      ],
    });
    /* END Slider */

    $('.owl-testimoials').owlCarousel({
      loop: true,
      margin: 0,
      nav: false,
      items: 1,
      lazyLoad: true,
      autoplay: true,
      autoplayHoverPause: true,
    });

    $('.owl-galerie').owlCarousel({
      loop: true,
      margin: 0,
      nav: false,
      items: 1,
      lazyLoad: true,
      autoplay: true,
      autoplayHoverPause: true,
    });

    $('.owl-actu-isp').owlCarousel({
      loop: true,
      autoplay: true,
      margin: 0,
      nav: false,
      items: 1,
      lazyLoad: true,
      dots: false,
    });

    $('.owl-actu').owlCarousel({
      loop: false,
      autoplay: true,
      margin: 50,
      nav: true,
      lazyLoad: true,
      dots: false,
      navText: [
        '<i class="fal fa-chevron-left"></i>',
        '<i class="fal fa-chevron-right"></i>',
      ],
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        991: {
          items: 3,
        },
      },
    });

    $('.owl-relation-temoignage').owlCarousel({
      loop: false,
      autoplay: true,
      margin: 0,
      nav: false,
      items: 1,
      lazyLoad: true,
      dots: true,
    });

    /* Collapse */
    $('.keeo-collapse .collapse-header').click(function() {
      $(this).parents('.keeo-collapse').toggleClass('active');
      /*var icon = $(this).find('svg');
      if(icon.attr('class').indexOf('fa-plus') != -1) {
        icon.removeClass('fa-plus');
        icon.addClass('fa-minus');
      }else if(icon.attr('class').indexOf('fa-minus') != -1) {
        icon.addClass('fa-plus');
        icon.removeClass('fa-minus');
      }*/
    });
    /* END Collapse */

    /* MapStyle */
    window.MapStyle = function() {
      var styles = [
          {
              'featureType': 'all',
              'elementType': 'labels.text.fill',
              'stylers': [
                  {
                      'saturation': 36,
                  },
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 40,
                  },
              ],
          },
          {
              'featureType': 'all',
              'elementType': 'labels.text.stroke',
              'stylers': [
                  {
                      'visibility': 'on',
                  },
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 16,
                  },
              ],
          },
          {
              'featureType': 'all',
              'elementType': 'labels.icon',
              'stylers': [
                  {
                      'visibility': 'off',
                  },
              ],
          },
          {
              'featureType': 'administrative',
              'elementType': 'geometry.fill',
              'stylers': [
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 20,
                  },
              ],
          },
          {
              'featureType': 'administrative',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 17,
                  },
                  {
                      'weight': 1.2,
                  },
              ],
          },
          {
              'featureType': 'landscape',
              'elementType': 'geometry',
              'stylers': [
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 20,
                  },
              ],
          },
          {
              'featureType': 'poi',
              'elementType': 'geometry',
              'stylers': [
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 21,
                  },
              ],
          },
          {
              'featureType': 'road.highway',
              'elementType': 'geometry.fill',
              'stylers': [
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 17,
                  },
              ],
          },
          {
              'featureType': 'road.highway',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 29,
                  },
                  {
                      'weight': 0.2,
                  },
              ],
          },
          {
              'featureType': 'road.arterial',
              'elementType': 'geometry',
              'stylers': [
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 18,
                  },
              ],
          },
          {
              'featureType': 'road.local',
              'elementType': 'geometry',
              'stylers': [
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 16,
                  },
              ],
          },
          {
              'featureType': 'transit',
              'elementType': 'geometry',
              'stylers': [
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 19,
                  },
              ],
          },
          {
              'featureType': 'water',
              'elementType': 'geometry',
              'stylers': [
                  {
                      'color': '#000000',
                  },
                  {
                      'lightness': 17,
                  },
              ],
          },
      ];
      return styles;
    };
    /* END MapStyle */
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js